import { __decorate } from "tslib";
import { Route } from '../core';
import config from '@api/config';
var VoucherCode = /*@__PURE__*/ (function () {
    function VoucherCode() {
    }
    VoucherCode.post = function (response) {
        return response;
    };
    VoucherCode = __decorate([
        Route(config.VOUCHER_CODE_ENDPOINT + "in-use/", true, true)
    ], VoucherCode);
    return VoucherCode;
}());
export { VoucherCode };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/voucher-code.ts
// module id = null
// module chunks = 